<div class="toolbar">
  <q9-toolbar>
    <div q9-left-content>
      <q9-section>
        <span title [title]="refModel.name">{{ refModel.name }}</span>
        <span content class="description">
          <span *ngIf="refModel.description" class="description-text">
            {{ refModel.description }}&nbsp;
          </span>
          <span *ngIf="refModel.external">
            ({{ orgInfo?.isSandbox ? 'Sandbox' : 'Production' }})
          </span>
        </span>
      </q9-section>
    </div>

    <div q9-right-content>
      <ng-container *ngIf="showShareRefModelButton">
        <q9-primary-button (click)="onShareRefModel()">
          {{ 'CORE.USER_ACCESS.SHARE_BTN' | translate }}
        </q9-primary-button>
      </ng-container>

      <ng-container *ngIf="isFree() || (isMsSpace() && !hasSubscription())">
        <span
          [matTooltip]="'CORE.BILLING.NEED_PERMISSIONS_UPGRADE' | translate"
          [matTooltipDisabled]="isTeamAdmin()"
          [matTooltipPosition]="'below'">
          <q9-primary-button
            class="upgrade-btn"
            (click)="openPricingCalculator()"
            [disabled]="!isTeamAdmin()">
            {{ 'CORE.GENERAL.UPGRADE' | translate }}
          </q9-primary-button>
        </span>
      </ng-container>

      <q9-theme-switcher></q9-theme-switcher>
      <ng-container *ngIf="refModel.external">
        <ng-container *ngTemplateOutlet="downloadLargeDatasetBtn"></ng-container>
      </ng-container>
      <q9-reports (reportAction)="showSavedReports($event)"></q9-reports>
      <q9-notifications></q9-notifications>
      <q9-profile-menu></q9-profile-menu>
    </div>
  </q9-toolbar>

  <q9-toolbar>
    <div q9-left-content>
      <button
        mat-button
        class="home-button"
        (click)="goHome()"
        matTooltipPosition="below"
        [matTooltip]="'TOOLTIPS.OPEN_REFMODELS_LIST' | translate">
        <mat-icon inline="true" matPrefix svgIcon="elements_logo-icon"></mat-icon>
        {{ 'SEARCH.TOOLBAR_TITLE' | translate }}
      </button>

      <mat-divider *ngIf="!isStripped" vertical="true"></mat-divider>
      <q9-icon-button
        icon="collapse"
        q9Track="TOOLTIPS.COLLAPSE"
        *ngIf="isShowLegacyNavActions && dataTypeModel === TreeListViewEnum.ALL"
        matTooltipPosition="below"
        matTooltip="{{ 'TOOLTIPS.COLLAPSE' | translate }}"
        (click)="collapseTree()"></q9-icon-button>
      <q9-icon-button
        *ngIf="isShowLegacyNavActions"
        icon="refresh"
        q9Track="TOOLTIPS.RELOAD"
        matTooltipPosition="below"
        matTooltip="{{ 'TOOLTIPS.RELOAD' | translate }}"
        (click)="refreshTree()"></q9-icon-button>

      <div
        *ngIf="showCodeSearchButton()"
        [matTooltip]="codeSearchButtonTooltip"
        matTooltipPosition="below">
        <q9-secondary-button
          [disabled]="syncInProgress() || (rootNodesLoading$ | async)"
          (click)="openCodeSearchModal()">
          {{ 'CORE.SIDEBAR.FIND_METADATA_REFERENCES' | translate }}
        </q9-secondary-button>
      </div>

      <app-view-selector
        *ngIf="isProPlusTeam"
        (updateSelectedView)="dataTypeChange($event)"></app-view-selector>

      <ng-container *ngIf="dataTypeModel === TreeListViewEnum.ALL">
        <q9-node-search [refModel]="refModel$ | async" [enableOverlay]="true"></q9-node-search>
      </ng-container>

      <ng-container *ngIf="dataTypeModel === TreeListViewEnum.MY_METADATA && sfTypes.length">
        <q9-sf-types-select
          [refModel]="refModel$ | async"
          [(ngModel)]="selectedSfType"
          (selectionChange)="onSfTypeSelectionChange($event)"></q9-sf-types-select>
      </ng-container>
    </div>

    <div q9-right-content>
      <ng-container *ngIf="refModel.external">
        <q9-primary-button
          *ngIf="
                  isShowAIChatButton &&
                  !isPlayground &&
                  hasManageOrEditPermissionsInOrg &&
                  hasAIAnalysisLicense()
                "
          q9Track="GPT.OPEN_ASK_ELEMENTS_TRACK"
          (click)="openConversation()">
          {{ 'AI_CHAT.ASK_ASSISTANT' | translate }}
        </q9-primary-button>

        <q9-primary-button
          *ngIf="refModel.lastSyncCompleted"
          q9Track="ACCESS_CHANGE_MONITORING_OPEN"
          (click)="goToAccessChangeMonitoring()">
          {{ 'CHANGE_MONITORING.ACCESS' | translate }}
        </q9-primary-button>

        <q9-primary-button
          *ngIf="refModel.lastSyncCompleted"
          q9Track="ARCHITECTURE_EXPLORER.ANALYTIC_360_TRACK_OPEN"
          (click)="goToSfAnalytics()">
          {{ 'ARCHITECTURE_EXPLORER.HEADER_TITLE' | translate }}
        </q9-primary-button>
      </ng-container>
    </div>
  </q9-toolbar>
</div>

<ng-template #downloadLargeDatasetBtn>
  <q9-icon-button
    icon="export-large-dataset"
    [matTooltip]="'REPORTS.DOWNLOAD_LARGE_DATASET' | translate"
    [q9Track]="'DOWNLOAD_LARGE_DATASET'"
    [matTooltipPosition]="'below'"
    [matMenuTriggerFor]="additionalMenu"></q9-icon-button>
  <mat-menu #additionalMenu="matMenu" class="q9-menu" [overlapTrigger]="false">
    <button mat-menu-item [matMenuTriggerFor]="automationsMenu">
      {{ 'REPORTS.TYPE_USED_FIELDS_BY_AUTOMATIONS' | translate }}
    </button>

    <div
      [matTooltip]="'REPORTS.SET_OBJECT_AS_ROOT_NODE' | translate"
      [matTooltipDisabled]="isObjectType">
      <button
        mat-menu-item
        [disabled]="!isObjectType"
        (click)="generateBigDataReport('refModelFieldDependencies')"
        q9Track="GENERATE_BIG_DATA_REPORT_FIELD_DEPENDENCIES">
        {{ 'REPORTS.TYPE_FIELD_DEPENDENCIES_REPORT' | translate }}
      </button>
    </div>
    <button
      mat-menu-item
      *ngIf="isProPlusTeam"
      (click)="generateBigDataReport('refModelPermissionSimilarityScore')"
      q9Track="GENERATE_BIG_DATA_REPORT_SIMILARITY_SCORE">
      {{ 'REPORTS.SIMILARITY_SCORE_REPORT_LABEL' | translate }}
    </button>
    <button
      mat-menu-item
      *ngIf="dataTypeModel === TreeListViewEnum.CUSTOM_METADATA && allowToDownloadCustomViewCsv"
      (click)="downloadCustomViewCsv()"
      q9Track="CUSTOM_VIEW_DOWNLOAD_CSV">
      {{ 'RUBIC_CUBE.DOWNLOAD_CSV' | translate }}
    </button>
  </mat-menu>
  <mat-menu #automationsMenu="matMenu" class="q9-menu" [overlapTrigger]="false">
    <button
      mat-menu-item
      *ngFor="let automationType of automationTypesList"
      (click)="generateBigDataReport('refModelUsedFields', automationType)"
      [q9Track]="'USED_FIELDS_REPORT_' + automationType">
      {{ automationType }}
    </button>
  </mat-menu>
</ng-template>

<div class="content">
  <div class="tree-list">
    <ng-container *ngIf="dataTypeModel === TreeListViewEnum.ALL; else metadataView">
      <app-node-tree-grid
        #treeGridWrapper
        class="need-pagination"
        [view]="dataTypeModel"
        [sfTypeFilter]="selectedSfType"
        (selectRow)="selectRowHandler($event)"
        (removeNode)="removeNode($event)"
        (makeNodeRoot)="makeNodeRoot($event)"
        (showMaxNodesDOMWarn)="showMaxNodesDOMWarnCallback($event)"></app-node-tree-grid>

      <div class="pagination">
        <div class="pagination-overlay" *ngIf="rootNodesLoading$ | async"></div>
        <div class="max-dom-nodes-warn">
          <span *ngIf="showMaxNodesDOMWarn">
            {{ 'PAGINATION.MAX_NODES_IN_DOM_WARN' | translate }}
          </span>
        </div>
        <mat-paginator
          color="primary"
          [length]="rootNodesLength$ | async"
          [pageIndex]="pageIndex$ | async"
          [pageSize]="nodesPerPageDefault"
          [pageSizeOptions]="pageSizeOptions"
          (page)="paginationChange($event)"></mat-paginator>
      </div>
    </ng-container>
    <ng-template #metadataView>
      <ng-container *ngIf="dataTypeModel === TreeListViewEnum.MY_METADATA; else customView">
        <app-my-metadata-view
          [sfTypeFilter]="selectedSfType"
          (selectRow)="selectRowHandler($event)"></app-my-metadata-view>
      </ng-container>

      <ng-template #customView>
        <app-custom-metadata-view
          [customMetadataView]="customMetadataView$ | async"
          (selectRow)="selectRowHandler($event)"></app-custom-metadata-view>
      </ng-template>
    </ng-template>
  </div>

  <q9-org-node-sidebar
    *ngIf="isExternalRefModel"
    [opened]="showSidebar$ | async"
    [disableClose]="false"
    [refModel]="refModelData"
    [orgInfo]="orgInfo$ | async"
    [node]="selectedNode$ | async"
    [dataPopulationInProgress]="isDpActive$ | async"
    (handleDeleteNode)="handleDelete($event)"
    (makeNodeRootClicked)="makeNodeRoot(selectedRow)"
    (createProposedNodeClicked)="addProposedNode(selectedRow)"
    (mpDataPopulationStarted)="onMpDpStarted()"></q9-org-node-sidebar>

  <q9rme-internal-node-sidebar
    *ngIf="!isExternalRefModel"
    [opened]="showSidebar$ | async"
    [disableClose]="false"
    [refModel]="refModelData"
    [orgInfo]="orgInfo$ | async"
    (makeNodeRootClicked)="makeNodeRoot(selectedRow)"
    [node]="selectedNode$ | async"></q9rme-internal-node-sidebar>
</div>
